"use client";

import { Link } from "@/i18n/navigation";
import LinkExternal from "next/link";
import { Icon } from "@iconify/react";
import { useTranslations } from "next-intl";

export const Footer = () => {
  const t = useTranslations("footer");

  return (
    <footer className="bg-background px-4 py-32 ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <div className="container">
        <div className="flex flex-row flex-wrap justify-between gap-12">
          {/* Colonne 1 - Informations */}
          <div className="flex flex-col gap-1">
            <h3 className="text-2xl font-extralight uppercase text-white">
              {t("companyName")}
            </h3>
            <p className="text-lg font-extralight uppercase text-white/80">
              {t("location")}
            </p>
            <p className="text-sm font-extralight uppercase text-white/60">
              {t("address.street")}
            </p>
            <p className="text-sm font-extralight uppercase text-white/60">
              {t("address.city")}
            </p>
          </div>

          {/* Colonne 2 - Contact */}
          <div className="flex flex-col gap-2">
            <p className="text-lg font-extralight text-white">{t("phone")}</p>
            <LinkExternal
              href="mailto:mareservationdelite@gmail.com"
              className="text-lg font-extralight text-white/80 hover:text-white"
            >
              mareservationdelite@gmail.com
            </LinkExternal>
          </div>

          {/* Colonne 3 - Liens légaux */}
          <div className="flex flex-col gap-2">
            <Link
              href="/mentions-legales"
              className="text-lg font-extralight uppercase text-white/80 hover:text-white"
            >
              {t("legal.terms")}
            </Link>
            <Link
              href="/cookies"
              className="text-lg font-extralight uppercase text-white/80 hover:text-white"
            >
              {t("legal.cookies")}
            </Link>
          </div>

          {/* Colonne 4 - Réseaux sociaux */}
          <div className="flex flex-col gap-2">
            <p className="text-lg font-extralight uppercase text-white">
              {t("social.followUs")}
            </p>
            <div className="flex gap-4">
              <LinkExternal
                href="https://www.instagram.com/chauffeurdelite/"
                target="_blank"
                className="text-white/80 hover:text-white"
              >
                <Icon icon="mdi:instagram" className="h-6 w-6" />
              </LinkExternal>
              <LinkExternal
                href="https://www.tripadvisor.fr/Attraction_Review-g187147-d12950071-Reviews-Chauffeur_d_elite-Paris_Ile_de_France.html"
                target="_blank"
                className="text-white/80 hover:text-white"
              >
                <Icon icon="simple-icons:tripadvisor" className="h-6 w-6" />
              </LinkExternal>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
